import { contramap } from "@asmbl/shared/sort";
import { isEmptyString } from "@asmbl/shared/utils";
import { LocationRow } from "../LocationsTable";

export function CountryCell({ value }: { value: string | null }): JSX.Element {
  return <>{isEmptyString(value) ? "N/A" : value}</>;
}

Object.assign(CountryCell, {
  Cell: CountryCell,
  id: "country" as const,
  Header: "Country" as const,
  accessor: "country" as const,
  width: 1.75,
  ordering: contramap((location: LocationRow) => location.country),
});
